export default {
    namespaced: true,
    
    getters: {
        getCartDiscountAmount(state, getters, rootState) {           
            const cartDiscount = rootState.cart.Discount;           
            let cartDiscountAmount = 0;

            if(!cartDiscount) return cartDiscountAmount;          

            const total = rootState.payment.TotalPrice || 0;

            if(isCartDiscountPercentage(cartDiscount) == true)
            {
                const discountCartPercentage = getCartDiscountPercentage(cartDiscount);

                cartDiscountAmount = getDiscountAmount(total, discountCartPercentage);

            }else
            {           
                cartDiscountAmount = getCartDiscountAmount(cartDiscount);                
            }            
            return cartDiscountAmount || 0; 
        },

        getPaymentMethodDiscountAmount(state, getters, rootState, rootGetters) {
            let paymentMethodDiscountAmount = 0;
            const cartDiscount = getters.getCartDiscountAmount;            
            let paymentMethoddiscountPercentage =  rootGetters['payment/getDiscount'];

            let amountWithCardDiscount = (rootState.payment.TotalPrice || 0) - cartDiscount;

            paymentMethodDiscountAmount = getDiscountAmount(amountWithCardDiscount, paymentMethoddiscountPercentage);
            return paymentMethodDiscountAmount || 0;
        },

        getDiscountAmount(state, getters) {
            return getters.getCartDiscountAmount + getters.getPaymentMethodDiscountAmount;            
        }    
    }    
};

function isCartDiscountPercentage(cartDiscount) {
    return cartDiscount.TypeId == 2;
}

function getCartDiscountPercentage(cartDiscount) {  
    return cartDiscount.Percentage || 0;
}

function getCartDiscountAmount(cartDiscount) {         
    return cartDiscount.Amount / 100 || 0;           
}
function  getDiscountAmount(amount, discountPercentage) {
    return ((amount * discountPercentage) / 100) || 0;
}